import React from 'react';

function Experience() {
  return (
    <div className='experience resume-main-content'>
        <div className='resume-heading'>
            <div className='main-heading'>
                <div className='bullet'></div>
                <span className='institution main-heading-content'>Iamneo.ai Edutech Pvt ltd, Coimbatore</span>
                <div className='year'>2022-Present</div>
            </div>
            <div className='sub-heading'>
                <span className='degree sub-heading-content'>Software Engineer</span> 
                <div className='sub-heading-details'> </div>
            </div>
        </div>
        <div className='resume-heading'>
            <div className='main-heading'>
                <div className='bullet'></div>
                <span className='institution main-heading-content'>Dr.Mahalingam College of Engg. and Technology</span>
                <div className='year'>2019-2022</div>
            </div>
            <div className='sub-heading'>
                <span className='degree sub-heading-content'>Assistant Professor</span> 
                <div className='sub-heading-details'> </div>
            </div>
        </div>

        <div className='resume-heading'>
            <div className='main-heading'>
                <div className='bullet'></div>
                <span className='institution main-heading-content'>Bannari Amman Institute of Technology</span>
                <div className='year'>2017-2019</div>
            </div>
            <div className='sub-heading'>
                <span className='degree sub-heading-content'>Assistant Professor</span> 
                <div className='sub-heading-details'> </div>
            </div>
        </div>

        <div className='resume-heading'>
            <div className='main-heading'>
                <div className='bullet'></div>
                <span className='institution main-heading-content'>QuEst Global Engineering Services Pvt Ltd</span>
                <div className='year'>2016</div>
            </div>
            <div className='sub-heading'>
                <span className='degree sub-heading-content'>Design Engineer</span> 
                <div className='sub-heading-details'> </div>
            </div>
        </div>

        <div className='resume-heading'>
            <div className='main-heading'>
                <div className='bullet'></div>
                <span className='institution main-heading-content'>GE India Technology Centre Pvt Ltd</span>
                <div className='year'>2015-2016</div>
            </div>
            <div className='sub-heading'>
                <span className='degree sub-heading-content'>Engineer-Fixed Term Hire</span> 
                <div className='sub-heading-details'> </div>
            </div>
        </div>
    </div>
    )
}

export default Experience;
